var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMovingForward = function SvgMovingForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 80,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 38,
    r: 36.25,
    fill: "#F2F4FE",
    stroke: "#000",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M38.264 22.965c2.405 0 4.354-2.455 4.354-5.483S40.668 12 38.264 12s-4.355 2.454-4.355 5.482 1.95 5.483 4.355 5.483"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M60.634 18.932 47.01 30.506a6.14 6.14 0 0 0-2.163 4.575l-.511 31.107a3.12 3.12 0 0 1-3.419 3.106 3.24 3.24 0 0 1-2.836-3.277V47.515"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.5,
    d: "M61.406 15.213c1.242 1.103.128 2.993-1.165 4.027L47.225 30.298c-.805.624-2.414 2.493-2.414 4.976v30.17c.086 1.294-.483 3.88-3.448 3.88-2.966 0-3.42-2.586-3.276-3.88v-6.637c-.086 1.724-1.293 3.017-2.758 3.017s-2.8-.924-2.8-4.2V34.177c0-1.793-1.38-3.333-2.07-3.88a16081 16081 0 0 0-13.275-11.119c-1.551-1.293-1.12-3.19-.603-3.62.517-.432 1.638-1.725 4.224.43 2.069 1.725 9.884 7.902 13.534 10.776h9.654l13.534-10.775c.776-.719 2.638-1.88 3.88-.776Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#041B93",
    d: "M76 34.647a34 34 0 0 1-.403 5.252c-4.885 2.356-16.184 6.647-34.78 7.061-18.868.465-30.92-3.242-36.056-5.281A34 34 0 0 1 4 34.654c4.656 1.943 16.96 6.057 36.788 5.577 19.067-.465 30.434-4.927 35.144-7.231.053.547.068 1.093.068 1.647"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M64.5 76C71.956 76 78 69.956 78 62.5S71.956 49 64.5 49 51 55.044 51 62.5 57.044 76 64.5 76Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#21A56E",
    d: "m65.447 61.548 3.69-5.254a1.84 1.84 0 0 1 2.39-.549 1.832 1.832 0 0 1 .598 2.67l-7.577 10.638a1.827 1.827 0 0 1-2.94.054l-2.004-2.566-1.11-1.438-.409-.535-.476-.665a1.83 1.83 0 0 1 .355-2.144l.13-.126a1.835 1.835 0 0 1 2.76.23l2.085 2.853a.188.188 0 0 0 .301 0l1.524-2.17z"
  })));
};
export default SvgMovingForward;